import { FC } from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type Props = {
	value?: string | null;
};

export const PersonaDetailDescription: FC<Props> = ({ value }) => {
	const theme = useTheme();

	return value ? (
		<Typography variant={'inherit'} fontSize={'14px'} fontWeight={'400'} textAlign={'center'} color={theme.palette.grey[600]}>
			{value}
		</Typography>
	) : null;
};
